import axios from "axios";

const ExternalRequest = () => {
    const config = {
        headers: { "Access-Control-Allow-Origin": "*" },
    };

    const get = async (url) => {
        try {
            const result = await axios.get(url);

            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    const post = async (url, body) => {
        try {
            const result = await axios.post(url, body || {}, config);

            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    const put = async (url, body) => {
        try {
            const result = await axios.put(url, body || {}, config);

            return result || {};
        } catch (error) {
            console.log(error);
        }
    };

    return { get, post, put };
};

export default ExternalRequest();
